var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.5C15.0938 5.5 16 6.40625 16 7.5V14.5C16 15.625 15.0938 16.5 14 16.5H2C0.875 16.5 0 15.625 0 14.5V7.5C0 6.40625 0.875 5.5 2 5.5H14ZM14 7H2C1.71875 7 1.5 7.25 1.5 7.5V14.5C1.5 14.7812 1.71875 15 2 15H14C14.25 15 14.5 14.7812 14.5 14.5V7.5C14.5 7.25 14.25 7 14 7ZM13.75 3C14.1562 3 14.5 3.34375 14.5 3.75C14.5 4.1875 14.1562 4.5 13.75 4.5H2.25C1.8125 4.5 1.5 4.1875 1.5 3.75C1.5 3.34375 1.8125 3 2.25 3H13.75ZM12.25 0.5C12.6562 0.5 13 0.84375 13 1.25C13 1.6875 12.6562 2 12.25 2H3.75C3.3125 2 3 1.6875 3 1.25C3 0.84375 3.3125 0.5 3.75 0.5H12.25Z",
    fill: "#227BA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRectangle);
export default __webpack_public_path__ + "static/media/icon_rectangle.4076c98b137b4382d747569df8c2dc94.svg";
export { ForwardRef as ReactComponent };